var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _circle2, _circle3, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 300",
    width: 800,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 300,
    rx: 16,
    fill: "#ffffff",
    stroke: "#dbe9f6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 460,
    height: 220,
    rx: 12,
    fill: "#f7fbff",
    stroke: "#dbe9f6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 70,
    width: 180,
    height: 16,
    rx: 8,
    fill: "#cfe3f7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 100,
    width: 380,
    height: 10,
    rx: 5,
    fill: "#e6edf3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 120,
    width: 320,
    height: 10,
    rx: 5,
    fill: "#e6edf3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 140,
    width: 260,
    height: 10,
    rx: 5,
    fill: "#e6edf3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 140,
    r: 44,
    fill: "#e8f1ff",
    stroke: "#cfe3f7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 140,
    r: 44,
    fill: "#e8f1ff",
    stroke: "#cfe3f7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 720,
    cy: 140,
    r: 44,
    fill: "#e8f1ff",
    stroke: "#cfe3f7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 200,
    width: 240,
    height: 36,
    rx: 10,
    fill: "#2563eb",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.0e2815616e10205a7fac39f4a5f4397d.svg";
export { ForwardRef as ReactComponent };